export default "__VITE_ASSET__CbMfC9dq__"